import styled from '@emotion/styled'
import React from 'react'
import { css } from '@emotion/react'
import { BlockSkeleton } from 'components/patterns/Skeleton/blocks/ShapedSkeletons'
import { InputState } from '../config'
import { ExampleLoanOffer } from 'generated/api'
import { ListWrapper } from './ListWrapper'
import { formatCurrencyLocale } from 'lib'
import { ThumborImg } from 'lib/images/ThumborImage'
import { redirectToApply } from '../utils'
import { Pending } from 'components/patterns/suspense/internals/types'
import { Button } from 'ui/inputs/Button/LegacyButtonCompatibility'

interface Props {
	offer: ExampleLoanOffer
	inputState: InputState
}

interface TextContentProps {
	text: string
	value: number
}

const TextContent: React.FC<React.PropsWithChildren<TextContentProps>> = ({ text, value }) => {
	return (
		<TextBlock>
			<span>{formatCurrencyLocale(value)}</span>
			<span>{text}</span>
		</TextBlock>
	)
}

const TextBlock = styled.div`
	display: flex;
	flex-direction: column;
`

export const OfferItemLoader: React.FC<React.PropsWithChildren<unknown>> = (): JSX.Element => {
	return (
		<ListWrapper>
			<>
				<OfferItem pending={true} />
				<OfferItem pending={true} />
				<OfferItem pending={true} />
			</>
		</ListWrapper>
	)
}

export const OfferItem: React.FC<React.PropsWithChildren<Pending<Props>>> = props => {
	let image, interest, monthly, button

	if (props.pending) {
		image = <BlockSkeleton />
		interest = <BlockSkeleton />
		monthly = <BlockSkeleton />
		button = <BlockSkeleton />
	} else {
		const {
			offer: { interestSaved, monthlyPayment, provider },
			inputState: { debtAmount }
		} = props
		image = <ThumborImg src={provider?.imageUrl} alt="Offer provider image" styles={Image} />
		interest = <TextContent text="Saved in Interest" value={interestSaved} />
		monthly = <TextContent text="Est. Mo. Payment" value={monthlyPayment} />
		button = (
			<Button variant="secondary" onClick={() => redirectToApply(debtAmount)}>
				Apply Now
			</Button>
		)
	}

	return (
		<ListItem>
			<ListItemImage>{image}</ListItemImage>
			<ListItemContent>
				<ListItemText>{interest}</ListItemText>
				<ListItemText>{monthly}</ListItemText>
				<ButtonWrapper>{button}</ButtonWrapper>
			</ListItemContent>
		</ListItem>
	)
}

const ListItem = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	border: solid 1px #e3e3e3;
	border-radius: 8px;
	padding: 16px;
`

const ListItemImage = styled.div`
	display: flex;
	margin-bottom: 24px;
	height: 90px;
`

const Image = css`
	width: 100%;
	height: 100%;
	object-fit: contain;
`

const ListItemContent = styled.div`
	display: flex;
	flex-direction: column;
`

const ListItemText = styled.div`
	width: 90%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	text-align: center;
	margin-bottom: 16px;
	height: 45px;
	span:nth-of-type(1) {
		font-size: 20px;
		font-weight: bold;
		margin-bottom: 4px;
	}
	span:nth-of-type(2) {
		font-size: 16px;
		color: #6e6e6e;
	}
`

const ButtonWrapper = styled.div`
	width: 100%;
	height: 48px;
	margin-top: 10px;
	button {
		min-width: 100%;
		padding: 0 16px;
	}
`
